import {LeftColumn, RightColumn} from "../Components/Column";
import Page from "./Page";

function AboutPage() {
    return (
      <Page title="About" image={{
          image: "about-erika.jpg",
          thumbAlt: "Erika Radich portrait",
          pixelWidth: 544,
          pixelHeight: 364
      }}>
          <LeftColumn>
              <div className="portfolio-subtitle">Statement</div>

              <p><em>"The rain-drenched stone that points the way" (Santoka)</em></p>

              <p>
                  The natural world and its complexities are the foundation of my art practice. I am mystified,
                  inspired, and humbled by the intricacies of the systems that inform and embody human existence and
                  provide the context in which we live.
              </p>

              <p>
                  The creatures and plants on earth in relationship with humans and their co-evolution is a moving,
                  breathing entity. It is a wonder to explore the tender and energetic meeting place where the two
                  intersect. There is a language here in this confluence&hellip;a dynamic cry or a soothing
                  whisper&hellip;that moves us forward, together. I am inspired by this relationship and its beauty,
                  mystery, and tragedy, and most of all its potential.
              </p>

              <p>
                  Remembering is fundamental to my work.  I commemorate my own losses within the ongoing transitions
                  of the natural world.
              </p>
          </LeftColumn>
          <RightColumn>
              <div className="portfolio-subtitle">
                  Bio
              </div>

              <p>
                  I started drawing as a child. It was my parents' bold aesthetics, and joy in "seeing," that
                  nurtured a fascination with the world just as it is. I have always felt a sense of wonder with how
                  things connect, are so "naturally" designed and how beauty, proportion, and composition exist
                  everywhere &#8212; in the natural world.
              </p>

              <p>
                  At college in Berlin, I was inspired by the German Expressionist movement to formalize my art
                  study. Print-making was added to the mix &#8212;becoming a compass and vehicle for creating
                  images. For me, printing and repeating images evokes a sense of practice, a feeling of
                  supplication and humility.
              </p>

              <p>
                  I have worked in and around the arts all my professional life. While much focus has been on arts
                  administration, my ongoing practice of drawing and printmaking continues to evolve. The enduring
                  thread between art and science inspires and guides all of my work.
              </p>

              <p>
                  In Keene, NH for the past 35 years, I have been director of the Grand Monadnock Arts Council,
                  director of the Monadnock Children's Museum, Community Development Director of the Redfern
                  Arts Center at Brickyard Pond at Keene State College, Publicist for the Colonial Theatre,
                  and Marketing Manager for Douglas Toy Company. I am now retired to work in the studio full
                  time. My work is exhibited regionally and internationally and is represented
                  by <a href="https://www.zeamaysprintmaking.com" className="news-link" target="_blank" rel="noreferrer">
                  Zea Mays Printmaking Studio and Gallery
              </a>, Florence, MA
                  and <a href="https://www.mitchellgiddingsfinearts.com/" className="news-link" target="_blank" rel="noreferrer">
                  Mitchell-Giddings Fine Arts
              </a>, Brattleboro, VT.
              </p>
          </RightColumn>
      </Page>
    );
}

export default AboutPage;
